import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import { format,parse } from 'date-fns';
import { takeWhile } from "rxjs/operators";


import {
    FvmsCommonService
    ,FvmsApiDtgUserService
    ,FvmsApiAuthService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    DtgActionType
    ,PagingInfo
} from "src/app/shared/vo";
import {DtgManageCarSearchComponent} from '../../../car';
import {DtgManageDriverSearchComponent} from '../../../driver';

@Component({
    templateUrl: './dtg.manage.schedule.drive.form.component.html'
    ,providers: []
})
export class DtgManageScheduleDriveFormComponent implements OnInit,OnDestroy,AfterViewInit {

    isContinue:boolean = true;
    currentUserInfo:any;
    @Input() companyId:string;
    @Input() userCarRunId:number;
    @Input() userId:string;
    @Input() dtgUnitId:string;
    @Input() dtgRegDtFrom:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    checkRegDt:boolean = false;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    }

    get f() { return this.formGroup.controls; }

    selectOneUserCarRunInfo(){
        let searchInfo = {
            userCarRunId : this.userCarRunId
        };
        this.fvmsApiDtgUserService.getOneUserCarRun(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // let tmpValue = apiResponse.resultValue;
                    this.formGroup.patchValue({
                      ...apiResponse.resultValue
                      ,dtgRegDtFrom: apiResponse.resultValue.dtgRegDtFrom.replace(/\s/g,"T")
                      ,dtgRegDtTo: apiResponse.resultValue.dtgRegDtTo.replace(/\s/g,"T")
                    });
                }
          });
    }

    ngOnInit(): void {
        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.selectOneUserCarRunInfo();
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                // this.checkSameId = true;
                this.selectOneUserCarRunInfo();
                // this.formGroup.disable();
                break;
        }
    }

    ngAfterViewInit(): void {
    }

    ngOnDestroy(): void {
        this.isContinue = false;
    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            userCarRunId:null
            ,userId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userNm:[
                ""
                ,[
                  Validators.required
                ]
            ]
            ,dtgUnitId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgCarNo:[
                ""
                ,[
                  Validators.required
                ]
            ]
            ,dtgRegDtFrom:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgRegDtTo:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,dtgRegDtYy:null
            ,dtgRegDtMm:null
            ,dtgRegDtDd:null
            ,dtgRegDtHh:null
            // ,dtgRegDtFromDate:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            // ,dtgRegDtToDate:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            // ,dtgRegDtFromTime:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            // ,dtgRegDtToTime:[
            //     ""
            //     ,[
            //         Validators.required
            //     ]
            // ]
            ,drivePathNm:null
            ,drivePathFromNm:null
            ,drivePathToNm:null
            ,useYn:"Y"
        });
    }


    clickOpenModalCarList(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.formGroup.patchValue({
                    dtgUnitId : resultModal.carInfo.dtgUnitId
                    ,dtgCarNo : resultModal.carInfo.dtgCarNo
                });
            }
        });
    }

    clickOpenModalUserList(dtgActionType:DtgActionType) {
        let modalRef = this.modalService.open(
            DtgManageDriverSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.formGroup.patchValue({
                    userId : resultModal.userInfo.userId
                    ,userNm : resultModal.userInfo.userNm || resultModal.userInfo.userId
                });
            }
        });
    }

    changeDtgRegDtFrom(regDtgRegDtFrom) {
        this.formGroup.patchValue({
            dtgRegDtFrom: regDtgRegDtFrom
        });
    }

    changeDtgRegDtTo(regDtgRegDtTo) {
        this.formGroup.patchValue({
            dtgRegDtTo: regDtgRegDtTo
        });
    }
/*
    changeDtgRegDate(regDate) {
        let tmpDtFrom = regDate + ' ' + this.f.dtgRegDtFromTime.value;
        let tmpDtTo = regDate + ' ' + this.f.dtgRegDtToTime.value;
        // this.f.dtgRegDtFromTime.value
        this.formGroup.patchValue({
            dtgRegDtFrom: tmpDtFrom
            ,dtgRegDtTo: tmpDtTo
            ,dtgRegDtToDate: regDate
        });
    }

    changeDtgRegTime(regTime, timeType) {
        let tmpTime = this.f.dtgRegDtFromDate.value + ' ' + regTime;
        if (timeType == 'from') {
            this.formGroup.patchValue({
                dtgRegDtFrom: tmpTime
            });
        } else if (timeType == 'to') {
            this.formGroup.patchValue({
               dtgRegDtTo: tmpTime
            });
        }
    }
*/

    // 일정 및 입력 날짜 검증
    checkDtgUserCarRun() {
        // 입력 값 검증
        if (this.f.dtgRegDtFrom.value > this.f.dtgRegDtTo.value) {
            this.checkRegDt = false;
            return;
        }
        // promise 생성
        let promise = new Promise((resolve,reject) => {
            let searchInfo = {
                companyId:this.companyId
                ,userCarRunId:this.f.userCarRunId.value
                ,dtgUnitId:this.f.dtgUnitId.value
                ,dtgRegDtFrom:this.f.dtgRegDtFrom.value
                ,dtgRegDtTo:this.f.dtgRegDtTo.value
            };

            this.fvmsApiDtgUserService.checkDtgUserCarRun(searchInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        let result = (apiResponse.resultValue === 0);
                        if(result){
                            this.checkRegDt = result;
                            resolve(result);
                        } else {
                            this.checkRegDt = false;
                            resolve(false);
                        }
                    }else{
                        this.checkRegDt = false;
                        resolve(false);
                    }
                });

        });

        return promise;
    }

    clickCancel() {
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave() {
        this.onSubmit();
    }


    onSubmit(){

        this.submitted = true;
        let userCarRunInfo = {
            userCarRunId:this.f.userCarRunId.value
            ,userId:this.f.userId.value
            ,userNm:this.f.userNm.value
            ,dtgUnitId:this.f.dtgUnitId.value
            ,dtgCarNo:this.f.dtgCarNo.value
            ,dtgRegDtFrom:this.f.dtgRegDtFrom.value.replace("T", " ")
            ,dtgRegDtYy:this.f.dtgRegDtYy.value
            ,dtgRegDtMm:this.f.dtgRegDtMm.value
            ,dtgRegDtDd:this.f.dtgRegDtDd.value
            ,dtgRegDtHh:this.f.dtgRegDtHh.value
            ,dtgRegDtTo:this.f.dtgRegDtTo.value.replace("T", " ")
            // ,dtgRegDtFromDate:this.f.dtgRegDtFromDate.value
            // ,dtgRegDtToDate:this.f.dtgRegDtToDate.value
            // ,dtgRegDtFromTime:this.f.dtgRegDtFromTime.value
            // ,dtgRegDtToTime:this.f.dtgRegDtToTime.value
            ,drivePathNm:this.f.drivePathNm.value
            ,drivePathFromNm:this.f.drivePathFromNm.value
            ,drivePathToNm:this.f.drivePathToNm.value
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
            ,useYn:this.f.useYn.value
        }
        // valid availability
        this.checkDtgUserCarRun().then((item:any)=>{
            let checkResult = item;
            // valid form data
            if (this.formGroup.invalid || checkResult === false) {
                return;
            }

            this.fvmsApiDtgUserService.upsertUserCarRun(userCarRunInfo)
                .pipe(takeWhile(() => this.isContinue))
                .subscribe(apiResponse => {
                    if(apiResponse.resultStatus === "ok"){
                        // 사용자 차량 운행 등록
                        this.fvmsApiDtgUserService.upsertUserCarRun(userCarRunInfo)
                          .pipe(takeWhile(() => this.isContinue))
                          .subscribe(apiResponse2 => {
                            // console.log("new user id",apiResponse2.resultValue.userId);
                          });
                    }
                    this.activeModal.close({
                        "result":"ok"
                    });
                });
        });
        return;
    }
}
